module.exports = __webpack_public_path__ + "img/about_back.c05f4d4e.svg";